module.exports = __webpack_public_path__ + "img/31.25c4846c.jpg";